export default __webpack_public_path__ + "static/media/analytics.6bcd03a5.svg";